function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#A0041E",
  d: "M32.436 2.821c1.801 1.799 3.779 2.737 0 6.517L12.884 28.889c-4.594 4.595-5.463 7.571-11.405 1.63-3.258-3.258.284-3.543 4.888-8.148l19.552-19.55c1.8-1.8 4.718-1.8 6.517 0z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#DD2E44",
  d: "M33.936 4.321a4.606 4.606 0 010 6.517L14.385 30.389c-4.073 4.073-8.342 4.693-11.405 1.63-3.258-3.258.284-3.543 4.888-8.148L27.42 4.321a4.606 4.606 0 016.516 0z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#3B88C3",
  d: "M15.301 33.18c.927.929 2.687.673 3.932-.572 1.244-1.244 1.501-3.004.572-3.932-.927-.928-2.688-.672-3.932.572-1.245 1.245-1.501 3.005-.572 3.932z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#3B88C3",
  d: "M19.068 27.937l-4.506 4.506.739.737 4.504-4.504z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#88C9F9",
  d: "M14.613 32.493c.928.928 2.688.672 3.932-.573 1.245-1.244 1.501-3.004.573-3.932-.928-.928-2.688-.672-3.932.572-1.245 1.246-1.501 3.005-.573 3.933z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#808285",
  d: "M17.651 29.396c.302.367.243.973-.207 1.423-.45.45-1.032.477-1.422.207-3.468-2.396-3.067-3.798-2.617-4.248.449-.45 1.148-1.148 4.246 2.618z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#A7A9AC",
  d: "M16.243 29.83c-1.103 1.237-2.763.609-3.935-.562-1.172-1.171-1.302-2.466-.13-3.638 1.171-1.172 2.36-.703 3.531.469 1.172 1.171 1.756 2.359.534 3.731z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#3B88C3",
  d: "M9.139 27.4c1.006 1.008 2.916.729 4.265-.621 1.351-1.35 1.628-3.259.622-4.266-1.006-1.007-2.916-.729-4.266.621-1.351 1.351-1.629 3.261-.621 4.266z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#3B88C3",
  d: "M13.226 21.712l-4.888 4.89.801.798 4.886-4.886z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#88C9F9",
  d: "M8.393 26.655c1.007 1.007 2.917.729 4.266-.622 1.351-1.35 1.628-3.259.622-4.266-1.006-1.007-2.916-.728-4.266.621-1.351 1.351-1.629 3.26-.622 4.267z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#3B88C3",
  d: "M11.651 23.396c.336.335.243.973-.207 1.423-.45.45-1.086.542-1.422.207-.335-.336-.243-.973.208-1.423.449-.45 1.085-.541 1.421-.207zm17.651-4.216c.927.929 2.687.673 3.931-.572 1.244-1.244 1.5-3.004.572-3.932-.928-.928-2.687-.672-3.931.572-1.245 1.246-1.502 3.005-.572 3.932z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#3B88C3",
  d: "M33.068 13.937l-4.505 4.507.739.736 4.503-4.504z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#88C9F9",
  d: "M28.614 18.494c.928.927 2.687.671 3.931-.573 1.244-1.244 1.5-3.004.572-3.932-.928-.928-2.686-.672-3.931.572-1.244 1.245-1.501 3.005-.572 3.933z"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#808285",
  d: "M31.65 15.397c.303.367.244.973-.207 1.423-.449.45-1.03.477-1.421.207-3.469-2.396-3.068-3.798-2.617-4.248.449-.45 1.149-1.149 4.245 2.618z"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#A7A9AC",
  d: "M30.243 15.831c-1.103 1.237-2.764.609-3.935-.562-1.172-1.171-1.302-2.466-.13-3.638 1.172-1.172 2.359-.703 3.531.469 1.173 1.17 1.756 2.358.534 3.731z"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#3B88C3",
  d: "M23.14 13.401c1.006 1.008 2.915.729 4.265-.621 1.351-1.35 1.628-3.259.622-4.266-1.007-1.007-2.916-.729-4.266.621-1.352 1.351-1.629 3.26-.621 4.266z"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#3B88C3",
  d: "M22.341 12.601l4.887-4.889.8.8-4.886 4.89z"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#88C9F9",
  d: "M22.394 12.656c1.006 1.007 2.916.729 4.266-.622 1.35-1.35 1.628-3.259.621-4.266-1.006-1.007-2.916-.729-4.266.621-1.351 1.351-1.629 3.26-.621 4.267z"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#3B88C3",
  d: "M25.651 9.397c.336.335.243.973-.207 1.423-.45.45-1.086.542-1.422.207-.336-.336-.243-.973.207-1.423.451-.45 1.086-.542 1.422-.207z"
});

var Svg1F6F9 = function Svg1F6F9(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 36 36"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

export default "data:image/svg+xml;base64,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";
export { Svg1F6F9 as ReactComponent };